import { render, staticRenderFns } from "./FollowModal.vue?vue&type=template&id=a2cc19ac&scoped=true"
import script from "./FollowModal.vue?vue&type=script&lang=js"
export * from "./FollowModal.vue?vue&type=script&lang=js"
import style0 from "./FollowModal.vue?vue&type=style&index=0&id=a2cc19ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cc19ac",
  null
  
)

export default component.exports